import {getSiteConfig} from '@/modules/Site';
import {Brand} from '../types/Brand';
import {BRANDS_BY_SITE} from '../config/Brands';

export const getBrandsFromSite = (): Brand[] => {
  const {site} = getSiteConfig();
  return BRANDS_BY_SITE[site];
};
